// The demo notice under the header (demo mode only): the sample data is not saved,
// and the next steps: Start free trial (once open; the app's sign-up form, filled in with
// the visitor's details by GET /api/demo/trial-link) and an onboarding call (the website's
// contact form).
import { useMeta } from "../api/meta";
import { Notice } from "../ui/Notice";

/** Start free trial in the demo: the API sends the browser on to the app's sign-up form. */
export const DEMO_TRIAL_LINK = "/api/demo/trial-link";

/** The trial address only if it is an absolute https URL, so a "javascript:" value can never become a link. */
export function safeTrialUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    return new URL(url).protocol === "https:" ? url : null;
  } catch {
    return null;
  }
}

export function DemoBanner() {
  const meta = useMeta();
  if (!meta.demoMode) return null;
  const trialUrl = safeTrialUrl(meta.demoTrialUrl);
  return (
    <Notice kind="info">
      You're exploring a demo with sample data. Nothing you do is saved.
      {meta.demoStartTrial ? (
        <>
          {" "}
          <a className="btn btn--secondary btn--small" href={DEMO_TRIAL_LINK}>
            Start free trial
          </a>
        </>
      ) : null}
      {trialUrl ? (
        <>
          {" "}
          <a className="btn btn--secondary btn--small" href={trialUrl}>
            Book an onboarding call
          </a>
        </>
      ) : null}
    </Notice>
  );
}
